import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { VERIFICATION_STATE } from '../constants';
import ImportLoading from '../import_loading/import_loading';
import Verification from '../import_loading/verification';
import { getImportRequest } from '../store/selectors';
import { setVerificationLabels, setVerificationState } from '../store/actions/verification';

const successMessages = {
  header: 'Your data has been',
  headerHighlight: 'mapped!',
  progressing: 'Mapping complete.'
};

export function Mapping({
  importRequest,
  setVerificationLabels,
  setVerificationState
}) {
  useEffect(() => {
    setVerificationState(VERIFICATION_STATE.IN_PROGRESS);
    setVerificationLabels({
      progressing: 'Mapping records...'
    });
  }, []);

  return (
    <div className="container new-import-verfication">
      <ImportLoading importStatus={['previewing']} successMessages={successMessages} />
      <Verification redirect={`/${importRequest.id}/preview`} />
    </div>
  );
}

Mapping.propTypes = {
  importRequest: PropTypes.object.isRequired,
  setVerificationLabels: PropTypes.func.isRequired,
  setVerificationState: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  importRequest: getImportRequest(state)
});

const mapDispatchToProps = {
  setVerificationLabels,
  setVerificationState
};

export default connect(mapStateToProps, mapDispatchToProps)(Mapping);
